// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    create: 'Opprett',
    new: 'Opprett nytt krav',
    role: 'Krav',
    delete: 'Slett',
    name: 'Navn',
    save: 'Lagre',
    confirm_delete: 'Bekreft sletting'
}